module.exports = __webpack_public_path__ + "static/media/speaker.80350719.svg";